import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=99916f06&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=99916f06&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99916f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99916f06')) {
      api.createRecord('99916f06', component.options)
    } else {
      api.reload('99916f06', component.options)
    }
    module.hot.accept("./inventoryList.vue?vue&type=template&id=99916f06&scoped=true", function () {
      api.rerender('99916f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Produce/rmcProDrugDosage/inventoryList.vue"
export default component.exports